import { ContractResolver } from './contract.resolver';
import { CommunicationsResolver } from './communications.resolver';
import { ForSigningResolver } from './forsigning.resolver';

export const APP_RESOLVES: any[] = [
  ContractResolver,
  CommunicationsResolver,
  ForSigningResolver
];



// WEBPACK FOOTER //
// ./src/app/resolves/index.ts